export type IMProject = 'chat' | 'newChat'

export interface IMEnvConfig {
  appKey: string
}

export interface IMProjectConfig {
  test: IMEnvConfig
  prod: IMEnvConfig
}

/**
 * 环信 IM 各业务项目的 appKey 配置（明文 org#app 格式）
 * - chat: 原客服聊天页
 * - newChat: 方德 IM（fd-im）新聊天页
 *
 * 环信 Web SDK 会根据 appKey 自动解析服务器地址，无需单独配置 apiUrl
 */
export const IM_CONFIGS: Record<IMProject, IMProjectConfig> = {
  chat: {
    test: {
      // localhost / 含 test 的域名（与原 im.ts 一致）
      appKey: 'alexma78818#ytxapp-jc-test',
    },
    prod: {
      // 正式域名（与原 im.ts 一致）
      appKey: 'alexma78818#ytxapp',
    },
  },
  newChat: {
    test: {
      // localhost / 含 test 的域名（与原 im.ts 一致）
      appKey: 'alexma78818#ytxapp-jc-test',
    },
    prod: {
      // 正式域名（与原 im.ts 一致）
      appKey: 'alexma78818#ytxapp',
    },
  },
}

export function isTestEnv(): boolean {
  return window.location.hostname.includes('test') || window.location.hostname.includes('localhost')
}

export function resolveIMConfig(project: IMProject): IMEnvConfig {
  const cfg = IM_CONFIGS[project]
  return isTestEnv() ? cfg.test : cfg.prod
}
